import { render, staticRenderFns } from "./RegistrationInProgressContainer.vue?vue&type=template&id=3d545804&scoped=true&lang=html&"
import script from "./RegistrationInProgressContainer.vue?vue&type=script&lang=js&"
export * from "./RegistrationInProgressContainer.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationInProgressContainer.vue?vue&type=style&index=0&id=3d545804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d545804",
  null
  
)

export default component.exports